import { EcdRoutes } from '../constants/routes';

export function getBasePath(language?: string, appName?: string) {
	const appPath = appName ? `/${appName}` : '';

	return `${language === 'en' ? '' : `/${language}`}/${EcdRoutes.ECDRoot}${appPath}`;
}

export function CleanURLSearchParams(searchParams: URLSearchParams): void{
	const keysForDel = [];
	searchParams.forEach(
		(value, key) => {
			if (!value ||  value === 'null' || value === 'undefined') {
				keysForDel.push(key);
			}
		});

	keysForDel.forEach(
		key => {
			searchParams.delete(key);
		});
}